const columns = [
    { name: 'Courses', uid: 'courseName' },
    { name: 'Day - Indian Standard Time (IST)', uid: 'day' },
    { name: 'Status', uid: 'status' },
    { name: 'QRCode', uid: 'qrCodeLink' },
    { name: 'Whatsapp', uid: 'whatsappLink' },
];

const users = [
    {
        id: 1,
        courseName: 'Morning Japa Group',
        time: '5:00am to 7:00am',
        day: 'Everyday',
        status: 'active',
        avatar: 'harinamCintamani.jpg',
        qrCodeLink: 'https://drive.google.com/file/d/1Xf2x-gDlTiACwWR1F-_AOFZVBZvWaMKy/view?usp=drive_link',
        whatsappLink: 'https://chat.whatsapp.com/IrGuIZK80npFZP4OeoR1GD',
    },
    {
        id: 2,
        courseName: 'Śrīmad-Bhāgavatam Study Group',
        time: '7:15am to 8:45am',
        day: 'Weekdays (Monday to Friday)',
        status: 'active',
        avatar: 'srimadBhagavatam.jpg',
        qrCodeLink: 'https://drive.google.com/file/d/143hClnfnMnbO9_AcGMHB_Ylp3X1qKfmT/view?usp=drive_link',
        whatsappLink: 'https://chat.whatsapp.com/I92aGgP5pWcDlc3cpE7mWQ',
    },
    {
        id: 3,
        courseName: 'Tattva Sandarbha',
        time: '12:00PM to 2:00PM',
        day: 'Monday & Wednesday',
        status: 'active',
        avatar: 'sadSandharbas.jpg',
        qrCodeLink: 'https://drive.google.com/file/d/1hS-Fur0PBPqE4MJBUxomC4K_0_1e30Bp/view?usp=drive_link',
        whatsappLink: 'https://chat.whatsapp.com/BYFxXrnBC1vBytkj9ymkmT',
    },
    {
        id: 4,
        courseName: 'Śrī Caitanya-Caritāmṛta',
        time: '8:00PM to 9:30PM',
        day: 'Monday,Tuesday & Friday',
        status: 'active',
        avatar: 'CC.jpg',
        qrCodeLink: 'https://drive.google.com/file/d/1ZpMi7w5YLF3T58h93pq_SlEhFk_9AL-Q/view',
        whatsappLink: 'https://chat.whatsapp.com/FdoJBSTkFwl9056raVNxSW',
    },
    {
        id: 5,
        courseName: 'Śrīmad-Bhāgavatam (Canto 10)',
        time: '12:00PM to 2:00PM',
        day: 'Tuesday & Thursday',
        status: 'active',
        avatar: 'srimadBhagavatam.jpg',
        qrCodeLink: 'https://drive.google.com/file/d/1Y4iMDvSHLMSan0SJTgIlCETPcOOeTT2X/view?usp=drive_link',
        whatsappLink: 'https://chat.whatsapp.com/Ih76MBp37B88YzW20kXM4A',
    },
    {
        id: 7,
        courseName: 'Śri Gopāla-Campu',
        time: '7:00PM to 8:30PM',
        day: 'Wednesday & Thursday',
        status: 'active',
        avatar: 'Gopala_Campu.jpg',
        qrCodeLink: 'https://drive.google.com/file/d/1gPz_I1y__Efe3ssl8_v9S6-A7dDjKfRO/view?usp=sharing',
        whatsappLink: 'https://chat.whatsapp.com/FrlteKYliwJAg9QTB0WnM1',
    },
    {
        id: 8,
        courseName: 'Bhakti Rasāmrta Sindhu: Southern Section',
        time: '12:00PM to 2:00PM',
        day: 'Friday',
        status: 'active',
        avatar: 'brs.jpg',
        qrCodeLink: 'https://drive.google.com/file/d/1kQtgiKeIo_qnn_zJh0OrKf56sQS5IrAQ/view?usp=drive_link',
        whatsappLink: 'https://chat.whatsapp.com/HxqYF52H26rEqJb41yrd8q',
    },
];

export { columns, users };